// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"-insights-header-filter-wrapper-1sajVS-"};